import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DCard',
  props: {
  header: { type: String, default: () => "" },
},
  emits: ["change"],
  setup(__props, { emit }) {





const value = ref("国内");

const onValueChange = () => {
  emit("change", value.value);
};

return { __sfc: true,emit, value, onValueChange }
}

})